import { render } from "./BaseCard.vue?vue&type=template&id=1f9750d9&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=1f9750d9&scoped=true&lang=css"

import exportComponent from "/Users/michaelp/Library/CloudStorage/OneDrive-個人/Visual Studio/Vue Complete/auth-09-adding-auto-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9750d9"]])

export default __exports__